import { useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { PUBLIC_NAV_ITEMS } from "@/lib/sections";

/** Mobile/tablet horizontal sections bar: one row, touch-scrollable inside itself, active item red + underlined. */
export default function SectionBar({ withLang, navLabel }) {
    const ref = useRef(null);
    const { pathname } = useLocation();
    useEffect(() => {
        const bar = ref.current; if (!bar) return;
        const active = bar.querySelector("[aria-current='page']");
        if (active) active.scrollIntoView({ block: "nearest", inline: "center", behavior: "smooth" });
    }, [pathname]);
    return (
        <nav className="section-bar lg:hidden border-t border-gray-100 dark:border-gray-800 bg-white" aria-label="الأقسام" data-testid="section-bar">
            <ul ref={ref} className="section-bar-track flex items-center gap-1 overflow-x-auto whitespace-nowrap px-3" role="list">
                {PUBLIC_NAV_ITEMS.map((item) => (
                    <li key={item.key} className="shrink-0">
                        <NavLink to={withLang(item.to)} end={item.end}
                            className={({ isActive }) => `section-bar-item nav-frame relative inline-flex items-center gap-1.5 min-h-[36px] px-3 text-[15px] font-bold ${isActive ? "nav-frame--active section-bar-item--active" : ""}`}
                            data-testid={`bar-nav-${item.key}`}>
                            {navLabel(item)}
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
}
